<template>

    <XIASearchBar :searchData="searchData" @search="search"/>
    <div class="title">
        设备租出情况统计
    </div>
    <TableComponent :tableObjet="tableObjet" :headers="headers">

    </TableComponent>
</template>

<script setup>
import TableComponent from '@/components/TableComponent.vue';
import XIASearchBar from '@/components/XIA-SearchBar.vue';
import {useDeviceTJ} from "@/use/statistics"

const {tableObjet,search,searchData,headers}=useDeviceTJ()
</script>
<style>
</style>